module.exports = __webpack_public_path__ + "static/media/goldImg.1cc5ffb0.png";